import React, { useCallback } from 'react';

import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import Async from 'react-select/async';

import {
  ClearIndicator,
  DropdownIndicator,
  NoOptionsMessage,
} from 'components/application/CollectionSelect';

import { formatDuration } from 'components/helpers/dates';

export default function SearchELearningCoursesField({
  fieldError,
  name,
  onError,
  onSelect,
  removeErrorStyling,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'courses.SearchELearningCoursesField',
  });

  const { t: i18nTCourses } = useTranslation('common', {
    keyPrefix: 'courses',
  });

  const loadELearningCourses = useCallback(
    _.debounce(
      (inputValue, callback) => {
        axios
          .get(`/e_learning_courses?search=${inputValue}`)
          .then((response) =>
            response.data.data.map((eLearningCourse) => ({
              label: eLearningCourse,
              value: eLearningCourse.id,
            })),
          )
          .then((options) => callback(options))
          .catch(() => onError());
      },
      500,
      { maxWait: 1000 },
    ),
    [],
  );

  return (
    <div
      className={classNames(
        fieldError.fieldHighlighted && 'collection-select--invalid',
      )}
    >
      <label className='field__label field__required tw-font-medium'>
        {i18nTCourses('courseName')}
      </label>
      <Async
        cacheOptions={true}
        className='collection-select__select-container'
        classNamePrefix='collection-select'
        components={{
          ClearIndicator,
          DropdownIndicator,
          NoOptionsMessage,
          Option,
        }}
        id={name}
        loadOptions={loadELearningCourses}
        name={name}
        onChange={onSelect}
        onFocus={() => removeErrorStyling({ target: { name } })}
        openMenuOnClick={false}
        placeholder={i18nT('placeholder')}
        value={null}
      />
    </div>
  );
}

function Option(props) {
  const { t: i18nTCourses } = useTranslation('common', {
    keyPrefix: 'courses',
  });

  const { durationParts, name } = props.data.label.attributes;

  return (
    <components.Option {...props}>
      <span className='tw-inline-flex tw-items-center'>
        <span>
          <div className='tw-text-grey-900'>{name}</div>
          <div className='tw-text-s tw-tracking-wide tw-text-grey-600'>
            {i18nTCourses('durationAnd1CreditPerCourse', {
              duration: formatDuration({ durationParts }),
            })}
          </div>
        </span>
      </span>
    </components.Option>
  );
}

SearchELearningCoursesField.propTypes = {
  name: PropTypes.string.isRequired,
  fieldError: PropTypes.object,
  removeErrorStyling: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

SearchELearningCoursesField.defaultProps = {
  fieldError: { fieldHighlighted: false },
};
